/**
 * Reset Password Request API Service
 * Handles password reset via token (from email link)
 */

import userManagementHttps from "../../axios/userManagement";
import { AxiosResponse } from "axios";
import { BaseResponse } from "../../db/response";
import normalizeBaseResponse from "../../utils/responseHandler";
import errorHandler from "../../utils/errorHandler";

export interface ResetPasswordRequestParams {
  email: string;
  password: string;
  confirmPassword: string;
}

export interface ResetPasswordRequestResponse extends BaseResponse {}

/**
 * Resets password using token (from email link)
 * Uses User Management API endpoint: /v1/userManagement/resetPassword
 * @param payload - Reset password request payload with email, password, confirmPassword
 * @returns Promise with reset password response
 * @throws Error if the request fails
 */
export async function resetPasswordRequest(
  payload: ResetPasswordRequestParams
): Promise<ResetPasswordRequestResponse> {
  console.log("🔵 resetPasswordRequest service: Making POST request", {
    endpoint: "resetPassword",
    email: payload.email,
    baseURL: `${import.meta.env.VITE_REACT_USER_MANAGEMENT_API || "http://localhost:9008"}/v1/userManagement`,
  });

  try {
    const response: AxiosResponse<ResetPasswordRequestResponse> =
      await userManagementHttps.post("resetPassword", payload);

    console.log("🟢 resetPasswordRequest service: Response received successfully", {
      status: response.status,
      statusText: response.statusText,
      requestURL: response.config.url,
      fullRequestURL: `${response.config.baseURL}${response.config.url}`,
      data: response.data,
    });

    return normalizeBaseResponse(response.data);
  } catch (error: any) {
    console.error("🔴 resetPasswordRequest service: Error occurred", {
      error,
      message: error?.message,
      response: error?.response?.data,
      status: error?.response?.status,
      statusText: error?.response?.statusText,
    });
    return errorHandler(error);
  }
}
